import React, {useState} from "react";
import {Button, Form, InputGroup,Dropdown , DropdownButton} from "react-bootstrap";

export default function PickWorkerSelect(props){

    const workers = props.workers;
    const [workerId, setWorkerId] = useState(()=>{
        if(props.default)
            return props.default

        return "";
    });
    const handlePickWorker = ()=>{
        props.onPick(workerId);
    }
    const useOnPickButon = props.withButton === true
    const onChange = (e)=>{

        //TODO: see whats problem
        // if(e.target.value.length<=0)
        //     return;

        if(useOnPickButon)
            setWorkerId(e.target.value);
        else
            props.onPick(e.target.value);
    }


    const onPickWokerType = (event)=>{
        props.onSetWorkerType(event.target.text)
    }


    return (
        <InputGroup className="mb-3">
            <DropdownButton
                variant="outline-secondary"
                title={props.workerType}
                id="input-group-dropdown-1"
                >
                <Dropdown.Item onClick={onPickWokerType} >Serwisant</Dropdown.Item>
                <Dropdown.Item onClick={onPickWokerType} >Opracował</Dropdown.Item>
                <Dropdown.Item onClick={onPickWokerType} >Koordynator Serwisu</Dropdown.Item>
                <Dropdown.Item onClick={onPickWokerType} >Kierownik Serwisu</Dropdown.Item>
            </DropdownButton>
            <Form.Select aria-label="Default select example" disabled={props.disabled} onChange={onChange}  defaultValue={workerId} >
                <option></option>
                {
                    workers?.map(worker=><option key={worker.id} value={worker.id}>{worker.name}</option> )
                }
            </Form.Select>
            {
                useOnPickButon &&
                <Button variant="outline-secondary" id="btn_add_worker" onClick={handlePickWorker}>
                    Dodaj
                </Button>
            }

        </InputGroup>
    )
}